import { UploadBasketItem } from '@epicuro-next/data/baskets';

export const parseItems = (textToParse: string): UploadBasketItem[] => {
  const lines = textToParse.split(/\r\n|\n|\r/).filter((line) => !!line.length);
  const uniqueMap = createUniqueRecords(lines);
  return Array.from(uniqueMap, ([code, quantity]) => ({ code, quantity }));
};

function createUniqueRecords(lines: string[]) {
  const uniqueMap = new Map<string, number>();

  lines.forEach((line) => {
    const [code, quantity] = line.trim().split(/\s+/);
    const quantityNumber = parseInt(quantity, 10);

    const previousQuantity = uniqueMap.get(code);

    if (previousQuantity) {
      uniqueMap.set(code, previousQuantity + quantityNumber);
    } else {
      uniqueMap.set(code, quantityNumber);
    }
  });

  return uniqueMap;
}
